enum RESPONSE_STATUS {
  ERROR = 'error',
  OK = 'ok',
  SUCCESS = 'success',
}

enum RESPONSE_MESSAGES {
  MICROCHIP_EXISTS = 'Microchip Already Registered',
  TRANSPONDER_EXISTS = 'Transponder already registered.',
  FIELDS_ERROR = 'Failed to validate some fields.',
}

export { RESPONSE_MESSAGES, RESPONSE_STATUS };
